/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmErc1155TransferLogInfo } from './EvmErc1155TransferLogInfo';
import type { EvmErc20TransferLogInfo } from './EvmErc20TransferLogInfo';
import type { EvmErc721TransferLogInfo } from './EvmErc721TransferLogInfo';
import type { EvmTrxDetailAccessInfo } from './EvmTrxDetailAccessInfo';

export type EvmTrxDetailInfo = {
    TRXA: string;
    TRXTP: EvmTrxDetailInfo.TRXTP;
    CBB: string;
    STATTP: EvmTrxDetailInfo.STATTP;
    BNO: string;
    AG: string;
    FROMADDRSINFO: EvmAddressSummaryInfo;
    TOADDRSINFO: EvmAddressSummaryInfo;
    VAL: string;
    TRXF: string;
    GP: string;
    GL: string;
    GU: string;
    GUP: string;
    BF: string;
    IP: string;
    ALIST: Array<EvmTrxDetailAccessInfo>;
    E20TLI: Array<EvmErc20TransferLogInfo>;
    E721TLI: Array<EvmErc721TransferLogInfo>;
    E1155TLI: Array<EvmErc1155TransferLogInfo>;
    UT: number;
    TRXID: string;
    SNO: string;
};

export namespace EvmTrxDetailInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }

    export enum STATTP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

